<template>
    <header-drop-menu v-if="!isNormalUser" label="设置" @command="onCommand">
        <!-- <isc-dropdown-item command="settings">公共设置</isc-dropdown-item> -->
        <isc-dropdown-item command="styles">外观设置</isc-dropdown-item>
        <!-- <isc-dropdown-item command="helps">帮助中心</isc-dropdown-item> -->

        <template #append>
            <the-appearance-settings-dialog ref="asd" />
            <the-common-settings-dialog ref="csd" />
        </template>
    </header-drop-menu>
</template>

<script>
import HeaderDropMenu from '@/components/desk-header/header-drop-menu';
import TheCommonSettingsDialog from '@/components/desk-header/components/the-common-settings-dialog';
import TheAppearanceSettingsDialog from '@/components/desk-header/components/the-appearance-settings-dialog';

export default {
    name: 'HeaderSettings',
    components: { TheAppearanceSettingsDialog, TheCommonSettingsDialog, HeaderDropMenu },
    computed: {
        isNormalUser() {
            try {
                return this.$store.state.sso?.loginName === 'user' || this.$store.state.sso?.role.includes('业务员');
            } catch (e) {
                return false;
            }
        }
    },

    methods: {
        onCommand(command) {
            switch (command) {
                case 'styles':
                    this.$refs.asd.open();
                    break;

                case 'settings':
                    this.$refs.csd.open();
                    break;

                case 'helps':
                    window.open(ENVS.remoteDocumentUrl);
                    break;
            }
        }
    }
};
</script>

<style lang="scss" scoped></style>
